module.exports = __webpack_public_path__ + "img/fenxiang.c1d6f24d.png";